import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typetatib";
var post = "/typetatib";
export const actGetDataTypetatib = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPETATIB" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPETATIB",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPETATIB", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPETATIB",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypetatib = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPETATIB" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type regulation has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_TYPETATIB", open: false }));
          return dispatch(actGetDataTypetatib());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPETATIB", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPETATIB",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypetatib = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPETATIB" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type regulation has been updated");
          dispatch(__openModal({ modal: "MODAL_EDIT_TYPETATIB", open: false }));
          return dispatch(actGetDataTypetatib());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPETATIB", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPETATIB",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypetatib = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPETATIB" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPETATIB",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPETATIB", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPETATIB",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypetatib = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPETATIB" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type regulation has been deleted");
          return dispatch(actGetDataTypetatib());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPETATIB", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPETATIB",
          message: "Network error..",
        });
      });
  };
};
